// extracted by mini-css-extract-plugin
export default {"Body":"_Body--gVbIp","Content":"_Content--n60zv","Footer":"_Footer--I2Bp3","Back":"_Back--zGKfL"};